import { localeAtom } from '@core/Atoms/Locale/Locale.atom';
import { Typography } from '@gds/Typography/Typography';
import { useAtomValue } from 'jotai';
import { CalculatorMessages } from '../FinancingCalculator/Calculator.messages';
import styles from './Header.module.css';

type Props = {
  strings: CalculatorMessages;
  handleHelpDialog?: () => void;
};

export const Header = ({ strings, handleHelpDialog }: Props) => {
  const locale = useAtomValue(localeAtom);

  return (
    <header className={styles.headerContainer}>
      <div className={styles.header}>
        <Typography variant="h4">{strings.wantToPayMonthly}</Typography>

        <Typography variant="body4" Component="p">
          {strings.introHeader}
        </Typography>
      </div>

      {locale === 'uk' && (
        <div className={styles.findOut}>
          <Typography variant="buttonLink3" onClick={handleHelpDialog}>
            {strings.findOut}
          </Typography>
        </div>
      )}
    </header>
  );
};
